import GroupMessageProvider from './GroupMessageProvider'

export default class UserGroupMessageProvider extends GroupMessageProvider {

    getGroupNameSingularKey = () => {
        return "common.User_Group"
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/UserGroupMessageProvider.js